import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/account/exchange_/start')({
  component: () => <Navigate to="/account/exchange" replace />,
});
